<template>
  <div>
    <full-page ref="fullpage" :options="options">
      <div
        class="section agribg"
        :style="
          `background-image:url(https://res.gosmart.mn/apps/ipom/bg_${this.$store.state.app.activeGroup.publicPage.mainTypeKey}.jpg)`
        "
      >
        <div class="container" style="height: calc(100vh - 80px)">
          <div class="d-flex align-items-center">
            <div class="">
              <div class="">
                <img
                  src="https://res.gosmart.mn/apps/ipom/logo.png?w=200"
                  class="rounded-circle wd-150 mg-b-20"
                  style="background: white; padding: 10px"
                />
                <h4 class="tx-xs-20 tx-uppercase tx-brand-02">
                  Оюуны өмчийн газар
                </h4>
                <h4 class="home-headline">
                  {{ $store.state.app.activeGroup.publicPage.systemName }}
                </h4>
              </div>
              <div class="row mg-t-50 mg-b-30">
                <div
                  v-for="(cat, i) in news_category"
                  class="col-sm-2 text-center"
                  :key="`cat_${i}`"
                >
                  <a
                    @click="
                      $router.push({
                        name: 'ipomLandings',
                        params: { lid: cat.id }
                      })
                    "
                    role="button"
                    class="text-center"
                  >
                    <div class="icon-container pd-5">
                      <img
                        :src="
                          `https://res.gosmart.mn/apps/ipom/${cat.field1}?w=300`
                        "
                        class="rounded-circle img-thumbnail"
                        :alt="cat.title"
                      />
                    </div>
                    <h6 class="mg-t-20 text-uppercase">{{ cat.title }}</h6>
                  </a>
                </div>
                <!-- <div class="col-sm-2 text-center">
                  <a  @click="$router.push({name: 'ipomLandings', params:{lid: 95326} })" role="button" class="text-center">
                    <div class="icon-container pd-5"><img    src="https://res.gosmart.mn/apps/ipom/module1.png" class="rounded-circle img-thumbnail" alt=""></div>
                    <h6 class="mg-t-20 text-uppercase">Зуучлалын үйл ажиллагаа эрхлэгч</h6>
                  </a>
                </div>
                <div class="col-sm-2 text-center">
                  <a @click="$router.push({name: 'ipomLandings', params:{lid: 95327}})" role="button" class="text-center">
                    <div class="icon-container pd-5"><img    src="https://res.gosmart.mn/apps/ipom/module2.jpeg" class="rounded-circle img-thumbnail" alt=""></div>
                    <h6 class="mg-t-20 text-uppercase">Оюуны өмчийн итгэмжлэгдсэн төлөөлөгч</h6>
                  </a>
                </div> -->
                <div class="col-sm-2 text-center"></div>
                <div class="col-sm-2 text-center">
                  <a
                    @click="$router.push({ name: 'login' })"
                    role="button"
                    class="text-center"
                  >
                    <div class="icon-container pd-5">
                      <img
                        src="https://res.gosmart.mn/apps/ipom/user.jpg?w=300"
                        class="rounded-circle img-thumbnail"
                        alt=""
                      />
                    </div>
                    <h6 class="mg-t-20 text-uppercase">Системд</h6>
                    <div class="btn btn-success btn-xs">нэвтрэх</div>
                  </a>
                </div>
                <div class="col-sm-2 text-center"></div>
                <div class="col-sm-2 text-center"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          class=""
          style="height: 80px; background-image: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,1));"
        >
          <div
            @click="$refs.fullpage.api.moveSectionDown()"
            role="button"
            class="text-center tx-white container"
          >
            <!-- <div>
              <h5 style="margin-bottom: 0px; color: white">Эхлэл</h5>
              <feather type="chevrons-down"></feather>
            </div> -->
          </div>
        </div>
      </div>
    </full-page>

    <b-modal
      v-model="modal.show"
      :title="modal.task.task"
      scrollable
      size="xl"
      no-fade
      hide-footer
    >
      <div class="my-4 mx-4" v-html="modal.task.taskDesc"></div>
    </b-modal>
  </div>
</template>

<style scoped>
.agribg {
  /* background: url('https://res.gosmart.mn/apps/ipom/bg.jpg'); */
  background-size: cover;
  background-position: top center;
}
@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
</style>
<style>
html {
  overflow: auto !important;
}
</style>

<script>
import { request } from "@/api/all";
var $ = window.$;

export default {
  data() {
    return {
      news_loading: false,
      news: [],
      news_category: [],
      news_category_cur: 0,
      options: {
        licenseKey: "YOUR_KEY_HEERE",
        sectionsColor: ["gray"],
        scrollOverflow: true
      },
      modal: {
        show: false,
        task: {
          task: "",
          taskDesc: ""
        }
      }
    };
  },
  mounted() {
    this.$nextTick(function() {
      // let platformScript = document.createElement('script')
      // platformScript.setAttribute('src', 'https://res.gosmart.mn/da/assets/js/dashforge.js')
      // document.head.appendChild(platformScript)

      $(window).trigger("resize");
    });

    if (window.location.hostname == "help.vetdrug.mn") {
      this.$router.push({ name: "vetLandingHelp", params: { cid: 0, id: 0 } });
    }

    this.initNewsCategory();
  },
  // created() {
  //   window.addEventListener("resize");
  // },
  // destroyed() {
  //   window.removeEventListener("resize");
  // },
  methods: {
    initNewsCategory() {
      request({
        api: { method: "GET", url: "Type/GetTreeData" },
        params: {
          parentId: 0,
          key: this.$store.state.app.activeGroup.publicPage.mainTypeKey
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.news_category = res.data.types;
        }
      });
    }
  }
};
</script>
